import { render, staticRenderFns } from "./ExploreComponent.vue?vue&type=template&id=2aa817c0&scoped=true"
import script from "./ExploreComponent.vue?vue&type=script&lang=js"
export * from "./ExploreComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa817c0",
  null
  
)

export default component.exports